import { inject } from "@angular/core";
import {
  CanActivateFn,
  Router,
  type MaybeAsync,
  type GuardResult,
} from "@angular/router";
import { AuthManager } from "../services/auth.service";
import { canViewDashboardFromSession } from "@core-interfaces/rbac/dashboard.permissions";

export const DashboardAccessGuard: CanActivateFn = (
  _route,
  _state,
): MaybeAsync<GuardResult> => {
  const auth = inject(AuthManager);
  const router = inject(Router);
  const session = auth.UserSessionData();
  if (canViewDashboardFromSession(session)) {
    return true;
  }
  return router.createUrlTree(["/prestaciones"]);
};
